export const races = [
  'Human',
  'Trolloc',
  'Myrddraal',
  'Dreadlord',
  'Seanchan'
];

export const homelands = {
  Trolloc: [
    {
      name: 'Beaked', //mostly correct? not 100% sure
      race: 'Trolloc',
      baseStats: { str: 15, int: 10, wil: 7, dex: 13, con: 15 },
      d100Chances: [2, 5, 15, 20, 16, 20, 15, 5, 2],
      maxStats: {
        Warrior: { str: 19, int: 14, wil: 10, dex: 17, con: 19 },
        Rogue:   { str: 18, int: 14, wil: 11, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 14, wil: 11, dex: 18, con: 19 }
      }
    },
    {
      name: 'Bearish', //100% correct
      race: 'Trolloc',
      baseStats: { str: 16, int: 5, wil: 6, dex: 10, con: 14 },
      d100Chances: [2, 5, 15, 20, 16, 20, 15, 5, 2],
      maxStats: {
        Warrior: { str: 21, int: 9, wil: 9, dex: 14, con: 17 },
        Rogue:   { str: 19, int: 9, wil: 10, dex: 17, con: 17 },
        Hunter:  { str: 20, int: 9, wil: 10, dex: 15, con: 17 }
      }
    },
    {
      name: 'Boarish', //100% correct
      race: 'Trolloc',
      baseStats: { str: 16, int: 8, wil: 7, dex: 12, con: 16 },
      d100Chances: [2, 5, 15, 20, 16, 20, 15, 5, 2],
      maxStats: {
        Warrior: { str: 19, int: 12, wil: 10, dex: 16, con: 19 },
        Rogue:   { str: 19, int: 12, wil: 11, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 12, wil: 11, dex: 17, con: 19 }
      }
    },
    {
      name: 'Ramshorned', //100% correct
      race: 'Trolloc',
      baseStats: { str: 15, int: 7, wil: 9, dex: 13, con: 16 },
      d100Chances: [2, 5, 15, 20, 16, 20, 15, 5, 2],
      maxStats: {
        Warrior: { str: 19, int: 11, wil: 12, dex: 17, con: 19 },
        Rogue:   { str: 18, int: 11, wil: 13, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 11, wil: 13, dex: 18, con: 19 }
      }
    },
    {
      name: 'Wolfish', //100% correct
      race: 'Trolloc',
      baseStats: { str: 15, int: 9, wil: 7, dex: 14, con: 15 },
      d100Chances: [2, 5, 15, 20, 16, 20, 15, 5, 2],
      maxStats: {
        Warrior: { str: 19, int: 13, wil: 10, dex: 18, con: 19 },
        Rogue:   { str: 18, int: 13, wil: 11, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 13, wil: 11, dex: 19, con: 19 }
      }
    },
  ],
  Myrddraal: [
    {
      name: 'Myrddraal',
      race: 'Myrddraal',
      baseStats: { str: 16, int: 14, wil: 12, dex: 14, con: 16 },
      d100Chances: [5, 10, 15, 15, 40, 5, 3, 4, 3],
      maxStats: null
    }
  ],
    Dreadlord: [
    {
      name: 'Dreadlord',
      race: 'Dreadlord',
      baseStats: { str: 15, int: 14, wil: 14, dex: 15, con: 14 },
      d100Chances: [5, 10, 10, 10, 45, 8, 4, 4, 4],
      maxStats: null
    },
  ],
  Human: [
    {
      name: 'Altara',
      race: 'Human',
      baseStats: { str: 14, int: 11, wil: 12, dex: 15, con: 13 },
      d100Chances: [10, 10, 10, 10, 45, 10, 5, 0, 0],
      maxStats: {
        Warrior:   { str: 19, int: 15, wil: 15, dex: 19, con: 19 },
        Rogue:     { str: 17, int: 15, wil: 16, dex: 19, con: 17 },
        Hunter:    { str: 19, int: 15, wil: 16, dex: 19, con: 18 },
        Channeler: { str: 16, int: 18, wil: 19, dex: 18, con: 14 }
      }
    },
    {
      name: 'Amadicia',
      race: 'Human',
      baseStats: { str: 14, int: 13, wil: 12, dex: 12, con: 16 },
      d100Chances: [1, 4, 9, 11, 50, 8, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 17, wil: 15, dex: 16, con: 19 },
        Rogue:     { str: 17, int: 17, wil: 16, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 17, wil: 16, dex: 17, con: 19 },
        Channeler: { str: 16, int: 19, wil: 19, dex: 15, con: 17 }
      }
    },
    {
      name: 'Andor',
      race: 'Human',
      baseStats: { str: 15, int: 14, wil: 13, dex: 14, con: 14 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 18, wil: 16, dex: 18, con: 19 },
        Rogue:     { str: 18, int: 18, wil: 17, dex: 19, con: 18 },
        Hunter:    { str: 19, int: 18, wil: 17, dex: 19, con: 19 },
        Channeler: { str: 17, int: 19, wil: 19, dex: 17, con: 15 }
      }
    },
    {
      name: 'Arad Doman',
      race: 'Human',
      baseStats: { str: 15, int: 11, wil: 11, dex: 14, con: 12 },
      d100Chances: [2, 8, 13, 13, 34, 10, 10, 8, 2],
      maxStats: {
        Warrior:   { str: 19, int: 15, wil: 14, dex: 18, con: 18 },
        Rogue:     { str: 18, int: 15, wil: 15, dex: 19, con: 16 },
        Hunter:    { str: 19, int: 15, wil: 15, dex: 19, con: 17 },
        Channeler: { str: 17, int: 18, wil: 18, dex: 17, con: 13 }
      }
    },
    {
      name: 'Arafel',
      race: 'Human',
      baseStats: { str: 16, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:     { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Channeler: { str: 18, int: 19, wil: 19, dex: 17, con: 16 }
      }
    },
    {
      name: 'Cairhien',
      race: 'Human',
      baseStats: { str: 14, int: 15, wil: 15, dex: 13, con: 13 },
      d100Chances: [4, 8, 13, 13, 30, 12, 8, 7, 5],
      maxStats: {
        Warrior:   { str: 19, int: 19, wil: 18, dex: 17, con: 19 },
        Rogue:     { str: 17, int: 19, wil: 19, dex: 19, con: 17 },
        Hunter:    { str: 19, int: 19, wil: 19, dex: 18, con: 18 },
        Channeler: { str: 16, int: 19, wil: 19, dex: 16, con: 14 }
      }
    },
    {
      name: 'Ghealdan',
      race: 'Human',
      baseStats: { str: 13, int: 14, wil: 14, dex: 13, con: 13 },
      d100Chances: [3, 13, 13, 13, 40, 8, 4, 3, 3],
      maxStats: {
        Warrior:   { str: 19, int: 18, wil: 17, dex: 17, con: 19 },
        Rogue:     { str: 16, int: 18, wil: 18, dex: 19, con: 17 },
        Hunter:    { str: 18, int: 18, wil: 18, dex: 18, con: 18 },
        Channeler: { str: 15, int: 19, wil: 19, dex: 16, con: 14 }
      }
    },
    {
      name: 'Illian',
      race: 'Human',
      baseStats: { str: 13, int: 14, wil: 14, dex: 15, con: 14 },
      d100Chances: [5, 10, 10, 10, 45, 8, 4, 4, 4],
      maxStats: {
        Warrior:   { str: 19, int: 18, wil: 17, dex: 19, con: 19 },
        Rogue:     { str: 16, int: 18, wil: 18, dex: 19, con: 18 },
        Hunter:    { str: 18, int: 18, wil: 18, dex: 19, con: 19 },
        Channeler: { str: 15, int: 19, wil: 19, dex: 18, con: 15 }
      }
    },
    {
      name: 'Kandor',
      race: 'Human',
      baseStats: { str: 16, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:     { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Channeler: { str: 18, int: 19, wil: 19, dex: 17, con: 16 }
      }
    },
    {
      name: 'Malkieri Diaspora',
      race: 'Human',
      baseStats: { str: 16, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:     { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Channeler: { str: 18, int: 19, wil: 19, dex: 17, con: 16 }
      }
    },
    {
      name: 'Mayene',
      race: 'Human',
      baseStats: { str: 12, int: 15, wil: 13, dex: 14, con: 13 },
      d100Chances: [8, 10, 15, 15, 27, 10, 8, 5, 2],
      maxStats: {
        Warrior:   { str: 18, int: 19, wil: 16, dex: 18, con: 19 },
        Rogue:     { str: 15, int: 19, wil: 17, dex: 19, con: 17 },
        Hunter:    { str: 17, int: 19, wil: 17, dex: 19, con: 18 },
        Channeler: { str: 14, int: 19, wil: 19, dex: 17, con: 14 }
      }
    },
    {
      name: 'Murandy',
      race: 'Human',
      baseStats: { str: 14, int: 11, wil: 12, dex: 15, con: 13 },
      d100Chances: [10, 10, 10, 10, 45, 15, 0, 0, 0],
      maxStats: {
        Warrior:   { str: 19, int: 15, wil: 15, dex: 19, con: 19 },
        Rogue:     { str: 17, int: 15, wil: 16, dex: 19, con: 17 },
        Hunter:    { str: 19, int: 15, wil: 16, dex: 19, con: 18 },
        Channeler: { str: 16, int: 18, wil: 19, dex: 18, con: 14 }
      }
    },
    {
      name: 'Saldaea',
      race: 'Human',
      baseStats: { str: 16, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:     { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Channeler: { str: 18, int: 19, wil: 19, dex: 17, con: 16 }
      }
    },
    {
      name: 'Shienar',
      race: 'Human',
      baseStats: { str: 16, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:     { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Channeler: { str: 18, int: 19, wil: 19, dex: 17, con: 16 }
      }
    },
    {
      name: 'Tarabon',
      race: 'Human',
      baseStats: { str: 14, int: 11, wil: 12, dex: 15, con: 13 },
      d100Chances: [10, 10, 10, 10, 45, 15, 0, 0, 0],
      maxStats: {
        Warrior:   { str: 19, int: 15, wil: 15, dex: 19, con: 19 },
        Rogue:     { str: 17, int: 15, wil: 16, dex: 19, con: 17 },
        Hunter:    { str: 19, int: 15, wil: 16, dex: 19, con: 18 },
        Channeler: { str: 16, int: 18, wil: 19, dex: 18, con: 14 }
      }
    },
    {
      name: 'Tear',
      race: 'Human',
      baseStats: { str: 15, int: 14, wil: 14, dex: 12, con: 14 },
      d100Chances: [1, 4, 12, 12, 42, 12, 12, 4, 1],
      maxStats: {
        Warrior:   { str: 19, int: 18, wil: 17, dex: 16, con: 19 },
        Rogue:     { str: 18, int: 18, wil: 18, dex: 19, con: 18 },
        Hunter:    { str: 19, int: 18, wil: 18, dex: 17, con: 19 },
        Channeler: { str: 17, int: 19, wil: 19, dex: 15, con: 15 }
      }
    },
    {
      name: 'Two Rivers',
      race: 'Human',
      baseStats: { str: 15, int: 12, wil: 14, dex: 12, con: 15 },
      d100Chances: [5, 10, 10, 10, 30, 10, 11, 10, 4],
      maxStats: {
        Warrior:   { str: 19, int: 16, wil: 17, dex: 16, con: 19 },
        Rogue:     { str: 18, int: 16, wil: 18, dex: 19, con: 19 },
        Hunter:    { str: 19, int: 16, wil: 18, dex: 17, con: 19 },
        Channeler: { str: 17, int: 19, wil: 19, dex: 15, con: 16 }
      }
    }
  ],
  Seanchan: [
    {
      name: 'Kirendad',
      race: 'Seanchan',
      baseStats: { str: 15, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [6, 8, 12, 12, 37, 15, 4, 4, 2],
      maxStats: {
        Warrior: { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:   { str: 18, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 16, wil: 16, dex: 19, con: 19 }
      }
    },
    {
      name: 'Noren M\'Shar',
      race: 'Seanchan',
      baseStats: { str: 16, int: 11, wil: 11, dex: 13, con: 15 },
      d100Chances: [6, 8, 12, 12, 37, 15, 4, 4, 2],
      maxStats: {
        Warrior: { str: 19, int: 15, wil: 14, dex: 17, con: 19 },
        Rogue:   { str: 19, int: 15, wil: 15, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 15, wil: 15, dex: 18, con: 19 }
      }
    },
    {
      name: 'Rampore',
      race: 'Seanchan',
      baseStats: { str: 16, int: 13, wil: 13, dex: 14, con: 14 },
      d100Chances: [6, 8, 12, 12, 37, 15, 4, 4, 2],
      maxStats: {
        Warrior: { str: 19, int: 17, wil: 16, dex: 18, con: 19 },
        Rogue:   { str: 19, int: 17, wil: 17, dex: 19, con: 18 },
        Hunter:  { str: 19, int: 17, wil: 17, dex: 19, con: 18 }
      }
    },
    {
      name: 'Seandar',
      race: 'Seanchan',
      baseStats: { str: 16, int: 12, wil: 12, dex: 14, con: 15 },
      d100Chances: [6, 8, 12, 12, 37, 15, 4, 4, 2],
      maxStats: {
        Warrior: { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:   { str: 19, int: 16, wil: 16, dex: 19, con: 19 },
        Hunter:  { str: 19, int: 16, wil: 16, dex: 19, con: 19 }
      }
    },
    {
      name: 'Shon Kifar',
      race: 'Seanchan',
      baseStats: { str: 15, int: 12, wil: 11, dex: 13, con: 14 },
      d100Chances: [6, 8, 12, 12, 37, 15, 4, 4, 2],
      maxStats: {
        Warrior: { str: 19, int: 16, wil: 14, dex: 17, con: 19 },
        Rogue:   { str: 18, int: 16, wil: 15, dex: 19, con: 18 },
        Hunter:  { str: 19, int: 16, wil: 15, dex: 18, con: 18 }
      }
    },
    {
      name: 'Tzura',
      race: 'Seanchan',
      baseStats: { str: 15, int: 12, wil: 12, dex: 14, con: 14 },
      d100Chances: [6, 8, 12, 12, 37, 15, 4, 4, 2],
      maxStats: {
        Warrior: { str: 19, int: 16, wil: 15, dex: 18, con: 19 },
        Rogue:   { str: 18, int: 16, wil: 16, dex: 19, con: 18 },
        Hunter:  { str: 19, int: 16, wil: 16, dex: 19, con: 18 }
      }
    }
  ]
};

export const professions = {
  Trolloc: [
    {
      name: 'Warrior',
      race: 'Trolloc',
      statModifiers: { str: +2, int: 0, wil: -1, dex: 0, con: +2 }
    },
    {
      name: 'Hunter',
      race: 'Trolloc',
      statModifiers: { str: 0, int: 0, wil: 0, dex: +1, con: 0 }
    },
    {
      name: 'Rogue',
      race: 'Trolloc',
      statModifiers: { str: -1, int: 0, wil: 0, dex: +3, con: 0 }
    },
  ],
  Myrddraal: [
    {
      name: 'Myrddraal',
      race: 'Myrddraal',
      statModifiers: { str: +1, int: 0, wil: +1, dex: +2, con: 0 }
    },
  ],
  Dreadlord: [
    {
      name: 'Dreadlord',
      race: 'Dreadlord',
      statModifiers: { str: -2, int: +3, wil: +3, dex: -1, con: -3 }
    }
  ],

  Human: [
    {
      name: 'Warrior',
      race: 'Human',
      statModifiers: { str: +2, int: 0, wil: -1, dex: 0, con: +2 }
    },
    {
      name: 'Hunter',
      race: 'Human',
      statModifiers: { str: +1, int: 0, wil: 0, dex: +1, con: +1 }
    },
    {
      name: 'Rogue',
      race: 'Human',
      statModifiers: { str: -1, int: 0, wil: 0, dex: +3, con: 0 }
    },
    {
      name: 'Channeler',
      race: 'Human',
      statModifiers: { str: -2, int: +3, wil: +3, dex: -1, con: -3 }
    }
  ],

  Seanchan: [
    {
      name: 'Warrior',
      race: 'Seanchan',
      statModifiers: { str: +2, int: 0, wil: -1, dex: 0, con: +2 }
    },
    {
      name: 'Hunter',
      race: 'Seanchan',
      statModifiers: { str: 0, int: 0, wil: 0, dex: +1, con: 0 }
    },
    {
      name: 'Rogue',
      race: 'Seanchan',
      statModifiers: { str: -1, int: 0, wil: 0, dex: +3, con: 0 }
    },
    {
      name: 'Channeler',
      race: 'Seanchan',
      statModifiers: { str: -2, int: +3, wil: +3, dex: -1, con: -3 }
    }
  ]
};

//build cumulative chances
for (const homeland of Object.values(homelands).flat()) {
  let cumulative = 0;
  homeland.d100Cumulative = homeland.d100Chances.map(chance => cumulative += chance);
}